import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';;
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { AdditionalServiceType, BusinessEnabledOption, InteractionType, KeyValues15, LocalService, PageKey, SupportingType, Wrappers15 } from 'src/service/local.service';
import { QrPaymentService } from 'src/service/qr-payment.service';

@Component({
  selector: 'app-qr-payment-logs',
  templateUrl: './qr-payment-logs.component.html',
  styleUrl: './qr-payment-logs.component.scss'
})
export class QrPaymentLogsComponent {
  BusinessEnabledOption = BusinessEnabledOption; AdditionalServiceType = AdditionalServiceType;
  lstSectionConfigKeys: string[] = ["common", "table", "qr_payment"];
  ctryCode: string = ''; businessId: string = ''; userId: string = ''; interactionType = 0; maxBodyHeight = 0;
  source: Wrappers15;

  constructor(public localService: LocalService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private qrPaymentService: QrPaymentService, private router: Router) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.businessId = routeParams.businessId;
      this.userId = routeParams.userId;
      this.configurationManagementService.ensurePageActions(PageKey.QrPaymentLogs, this.businessId);
      if (this.interactionType != InteractionType.User && (this.businessId == '' || this.businessId == '0')) {
        this.localService.redirectToSeller();
      } else {
        this.localService.saveUrl();
        this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType, routeParams.businessId);
        this.ctryCode = routeParams.ctryCode;
        this.onInitiate();
        this.onLoad();
      }
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {

  }

  isProcessing = false;
  onLoad() {
    if (!this.isProcessing) {
      this.isProcessing = true;
      this.qrPaymentService.getQrPaymentLogs(this.businessId, this.source && this.source.paging ? this.source.paging : undefined).subscribe(result => {
        this.source = result;
        this.isProcessing = false;
      });
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        const item = this.source.items.find(x => x.key == key);
        if (item) {
          this.onRouting(item);
        }
      } break;
    }
  }

  onRouting(item: KeyValues15) {
    switch (parseInt(item.v5)) {
      case SupportingType.Billing: {
        this.router.navigate(['/billing' + this.localService.basicParamsString, this.businessId, item.v4]);
      } break;
    }
  }
}
